import React from 'react';

import { EmailEntryFiles, EmailFileEntry } from '@/src/components/project/Inbox2/types';

import EmailFileEntryViewer from '../../../EmailFileEntryViewer/EmailFileEntryViewer';

type FileViewerProps = {
  emailId: number;
  inboxEntryId: number;
  emailFileEntry: EmailFileEntry;
  files: EmailEntryFiles;
  isSentEmailType: boolean;
  onSetEmailFileEntry: (emailFileEntry: any) => void;
};

const FileEntryViewer = ({
  inboxEntryId,
  emailId,
  files,
  isSentEmailType,
  ...otheProps
}: FileViewerProps) => {
  return (
    <React.Fragment>
      <EmailFileEntryViewer
        inboxEntryId={inboxEntryId}
        emailId={emailId}
        allFiles={files.list}
        isSentEmailType={isSentEmailType}
        {...otheProps}
        totalCount={files.total}
      />
    </React.Fragment>
  );
};

export default FileEntryViewer;
